<template>
  <div v-if="opqIf">
    <infobulle :descriptionPopup="descriptionPopup">
      <label :for="idInner" v-if="libelleLong"><div v-html="libelleLong" class="mb-1"></div></label>
      <v-textarea
        :style="{ width: width + 'px' }"
        v-bind="$attrs"
        :value="innerValue"
        outlined
        dense
        :id="idInner"
        :rules="textAreaRules"
        @input="handleInput"
        @blur="handleBlur"
        :label="label"
        :loading="updating"
        :disabled="updating"
        ref="textArea"
        :counter="showCounter"
        :maxlength="maxLength"
      ></v-textarea>
    </infobulle>
  </div>
</template>

<script>
import ChampBase from "@/mixins/ChampBase"
import { Api, Queue } from "@/plugins/api"

// @group Champs
export default {
  props: {
    width: { type: String, default: "800" },
    value: String,
    code: { type: String, required: true },
    optional: Boolean,
    live: { type: Object },
    // Variable qui lorsqu'elle passe à false, déclenche un clear du champ
    opqIf: { type: Boolean, default: true },
    id: { type: String }
  },

  mixins: [ChampBase],

  data() {
    return {
      updating: false,
      innerValue: "",
      maxLength: 8000
    }
  },

  methods: {
    handleInput(event) {
      this.$emit("input", event)
    },
    handleBlur(event) {
      if (this.live && (event.target.value ?? "").length <= this.maxLength) {
        this.updating = true
        Queue.enqueue(() =>
          Api.post(this.live.endpoint, {
            fileId: this.live.fileId,
            cle: this.live.cle,
            value: event.target.value
          }).finally(() => {
            this.updating = false
          })
        )
      }
      this.$emit("blur", event)
    }
  },

  created() {
    this.innerValue = this.value
  },

  computed: {
    textAreaRules() {
      return [(v) => ((v ?? "").length <= this.maxLength && (this.optional || !!v)) || "Ce champ est obligatoire"]
    },
    showCounter() {
      return !!this.innerValue && this.innerValue.toString().length >= 7500
    }
  },

  watch: {
    opqIf(newValue) {
      if (!newValue) {
        this.innerValue = ""
        this.$refs.textArea.clearableCallback()
        this.handleBlur({ target: { value: null } })
      }
    },
    value(newVal) {
      this.innerValue = newVal
    }
  }
}
</script>

<style>
</style>